import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { id } from '@swimlane/ngx-charts/release/utils';

@Component({
  selector: 'ngx-add-direcciones-extra',
  templateUrl: './add-direcciones-extra.component.html',
  styleUrls: ['./add-direcciones-extra.component.scss']
})
export class AddDireccionesExtraComponent implements OnInit {

  @Input() id;
  @Input() data;
  @Output() deleteIdDirecciones = new EventEmitter();
  @Output() cambioValorArrayDirecciones = new EventEmitter();

  random_id =  Math.floor((Math.random() * 1000000000000) + 1);

  constructor() { }

  ngOnInit() {
  }

  public CambiaValorInput(event,ref?,id?){
    let elemento = event.target.tagName;
    let tipo = event.target.type;
    if (elemento == "INPUT" && tipo == "text"){
      this.cambioValorArrayDirecciones.emit({
        'identificador': id,
        'inputType': "text",
        'key': event.target.name,
        'value': event.target.value
      });
    }
    if (elemento == "INPUT" && tipo == "radio"){
      if (ref){

        switch(ref){
          case "_es_particular": 
          this.cambioValorArrayDirecciones.emit({
            'identificador': id,
            'inputType': "radio",
            '_es_particular' : true,
            '_es_alternativa' : false,
            '_es_profesional' : false
          });
          ;break;

          case "_es_alternativa": 
          this.cambioValorArrayDirecciones.emit({
            'identificador': id,
            'inputType': "radio",
            '_es_particular' : false,
            '_es_alternativa' : true,
            '_es_profesional' : false
          });
          ;break;

          case "_es_profesional": 
          this.cambioValorArrayDirecciones.emit({
            'identificador': id,
            'inputType': "radio",
            '_es_particular' : false,
            '_es_alternativa' : false,
            '_es_profesional' : true
          });
          ;break;

          
        }
      }
    }
  }

  public deleteDirecciones(id?){
    this.deleteIdDirecciones.emit({
      'id' : id
    });
  }

}
